import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import { SpinnerButton } from "@asez/component-library";
import { SIZES } from "@asez/shared";
import { STATIC_STRINGS } from "@asez/shared";
import useFileUpload from "./hooks/useFileUpload";
import { getFileSize } from "../../../../../utils";

const handleDownloadFileFormat = () => {
  const rows = STATIC_STRINGS.FILE_FORMAT_ROWS;

  let csvContent = STATIC_STRINGS.CSV_CONTENT;

  rows.forEach((rowArray) => {
    let row = rowArray.join(",");
    csvContent += row + "\r\n";
  });

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", STATIC_STRINGS.DOWNLOAD_FILE_NAME);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const FileUploadCard = () => {
  const {
    file,
    fileName,
    uploadSuccess,
    uploading,
    fileInputRef,
    handleFileChange,
    handleUploadClick,
  } = useFileUpload();

  return (
    <div className="w-1/2 mx-1 card rounded-lg h-full p-3 flex flex-col justify-between items-start border">
      <div className="font-semibold">{STATIC_STRINGS.UPLOAD_HEADING}</div>
      <div className="text-gray-600 font-medium flex flex-col justify-around items-start h-1/2 w-full">
        {fileName && file ? (
          uploadSuccess ? (
            <div>
              {fileName} {STATIC_STRINGS.UPLOADED_SUCCESSFULLY}
            </div>
          ) : (
            <>
              <div>
                {STATIC_STRINGS.SELECTED}:
                <span className="text-gray-600 font-semibold">{` ${fileName} [${getFileSize(
                  file?.size
                )}]`}</span>
              </div>
              <div>
                {STATIC_STRINGS.UPLOAD_PROMPT_BEFORE}
                <span className="text-neutral-dark">
                  {STATIC_STRINGS.UPLOAD_FILE}
                </span>
                {STATIC_STRINGS.UPLOAD_PROMPT_AFTER}
              </div>
            </>
          )
        ) : (
          STATIC_STRINGS.UPLOAD_SUBHEADING
        )}
      </div>
      <div className="flex flex-col h-1/3 xl:flex-row justify-between items-end w-full">
        <input
          type="file"
          accept=".csv, .xlsx"
          onChange={handleFileChange}
          className="hidden"
          ref={fileInputRef}
        />
        <button
          className="btn btn-outline px-2 py-1 flex justify-center items-center shadow-md text-sm 2xl:text-base w-full xl:w-fit"
          onClick={handleDownloadFileFormat}
        >
          <DownloadIcon className="mr-1" fontSize={SIZES.sm} />
          {STATIC_STRINGS.DOWNLOAD_FORMAT}
        </button>
        <SpinnerButton
          className={`btn btn-outline p-1 flex items-center justify-center w-full xl:w-36 shadow-md text-sm 2xl:text-base ${
            file && `cursor-pointer`
          }`}
          loading={uploading}
          size={SIZES.sm}
          variant="outline"
          onClickHandler={handleUploadClick}
        >
          <div className={`flex items-center ${file ? "cursor-pointer" : ""}`}>
            <UploadFileIcon className="mr-1" fontSize={SIZES.sm} />
            {file ? STATIC_STRINGS.UPLOAD_FILE : STATIC_STRINGS.SELECT_FILE}
          </div>
        </SpinnerButton>
      </div>
    </div>
  );
};

export default FileUploadCard;
